import { BatchActionProps } from './action-bar.types';
import { FileExportIcon, TableIcon, FloppyDisk, PlusIcon, ListTreeIcon } from '../..';

const wrapperClasses = 'flex flex-nowrap items-center text-sm leading-6 text-primary font-medium cursor-pointer';

export const BatchAction = ({ type = 'custom', ...props }: BatchActionProps) => {
  const { name, icon, onClick } = props;
  const label = {
    export: 'Export results',
    custom: name,
    customize: 'Customize',
    saveView: 'Save view',
    import: 'Import',
    group: 'Group',
  }[type];
  const actionIcon = {
    export: FileExportIcon,
    custom: icon,
    customize: TableIcon,
    saveView: FloppyDisk,
    import: PlusIcon,
    group: ListTreeIcon,
  }[type];
  const styles = {
    export: ' mr-8',
    custom: ' mr-8',
    customize: ' ml-auto',
    saveView: ' mr-8',
    import: ' mr-8',
    group: ' mr-8',
  }[type];

  return (
    <div data-testid="batch-action" className={wrapperClasses + styles} onClick={onClick}>
      <div className="pr-2">{actionIcon && actionIcon({ className: 'w-5 h-4 text-primary fill-current' })}</div>
      {label}
    </div>
  );
};

export default BatchAction;
